import { ApiImageContainer } from '@ibe/api';
import LinkedImage from './LinkedImage';

export default class CmsGlobalElements {
  mapStaticImage?: ApiImageContainer;

  showNewMap?: boolean;

  headerImage?: ApiImageContainer;

  headerHref?: string;

  footerText?: string;

  footerImages?: LinkedImage[];
}
